import { Grid, Icon, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useState } from "react";
import MockTooltipComponent from "./MockTooltipComponent";
import supplierIcon from "../../assets/images/green.svg";

const MockGlobalRiskCompanyModal = ({ onCallBack }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        classes={{
          paper: classes.dialog,
        }}
      >
        <MockTooltipComponent
          placement="top-start"
          open={open}
          popper={classes.companyTooltip}
          tooltipArrowStyle={classes.locationArrowStyle}
          title={
            <>
              <Typography className={classes.tooltipTitleStyle}>
                Check on your suppliers
              </Typography>
              <p className={classes.tooltipTextStyle}>
                The locations of your suppliers are marked in green. 
                <span className={classes.newLine}>
                Click on them to show relevant risks.
                </span>
              </p>
              <div
                style={{
                  width: "64px",
                  padding: "8px",
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  fontWeight: 600,
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpen(false);
                  onCallBack();
                }}
              >
                <span>Continue</span>
              </div>
              <Typography className={classes.stepTextStyle}>
                (18/19)
              </Typography>
            </>
          }
          child={
            <div className={classes.modalRoot}>

              <Grid container spacing={2}>
                <Grid item xs={10}>
                  <div style={{ display: "flex" }}>
                    <img src={supplierIcon} className={classes.supplierIcon} />
                    <Typography className={classes.composeEmailStyle}>
                      Sunny Cotton Company
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={1}>
                  <Icon
                    baseClassName="fas"
                    className="fa solid fa-xmark"
                    style={{
                      fontSize: "16px",
                      color: "#000000",
                      marginLeft: "16px",
                      opacity: 0.5,
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "16px" }}>
                <Grid item xs={12}>
                  <Typography
                    className={classes.newsText}
                  >{`Motijheel, Dhaka- 1000, India`}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <p
                    className={classes.reportAffectedText}
                    style={{ marginTop: "10px" }}
                  >
                    3 <u>risks</u> are affecting this supplier.
                  </p>
                </Grid>
              </Grid>
            </div>
          }
        />
      </Dialog>
    </div>
  );
};

export default MockGlobalRiskCompanyModal;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "348px",
    height: "170px",
    padding: "32px 20px",
    overflow: "hidden",
  },
  composeEmailStyle: {
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: "700",
    lineHeight: "24px",
  },
  newsText: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 400,
    opacity: 0.75,
  },
  backDrop: {
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(255,255,255,0.01)",
  },
  dialog: {
    position: "absolute",
    left: "40%",
    top: "30%",
  },
  reportAffectedText: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "300",
    margin: 0,
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: "700",
    marginBottom: '16px'
  },
  companyTooltip: {
    width: "475px",
    maxWidth: '500px !important',
    height: "148px",
    marginBottom: '36px !important',
    marginLeft: '-24px !important'
  },
  locationArrowStyle: {
    color: '#373D3F'
  },
  supplierIcon: {
    paddingRight: "10px"
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  newLine: {
    display: "block",
    marginTop: "15px"
  }
}));
